const statusSiteUserAdvertiser = {
  PENDING: "در حال انتظار",
  CONFIRM: "تایید شده",
  REJECT: "رد شده",
};

const statusSiteUserAdvertiserNumber = {
  PENDING: 1,
  CONFIRM: 2,
  REJECT: 3,
};

const statusSiteUserAdvertiserString = () => {
  let data = {};
  data[statusSiteUserAdvertiser.PENDING] = "در حال انتظار";
  data[statusSiteUserAdvertiser.CONFIRM] = "تایید شده";
  data[statusSiteUserAdvertiser.REJECT] = "رد شده";

  return data;
};

export default {
  statusSiteUserAdvertiser,
};
